const config = {
    baseUrl: 'http://127.0.0.1:9900',
    api:'c04bedf69172991e351de4803e3252a3'
   };
   
export default config;